import { Directive, Input } from '@angular/core';
import {
	AbstractControl,
	NG_VALIDATORS,
	ValidationErrors,
	Validator,
	ValidatorFn,
} from '@angular/forms';

@Directive({
	selector: '[minLength], [minLengthLabel]',
	providers: [
		{ provide: NG_VALIDATORS, useExisting: MinLengthDirective, multi: true },
	],
	standalone: false,
})
export class MinLengthDirective implements Validator {
	@Input('minLength') minLength: number;
	@Input('minLengthLabel') minLengthLabel: string;

	validate(control: AbstractControl): ValidationErrors | null {
		return this.minLength
			? MinLengthValidator(this.minLength, this.minLengthLabel)(control)
			: null;
	}
}

export function MinLengthValidator(
	minLength: number,
	minLengthLabel: string,
): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		const { value } = control;

		return !value
			? null
			: value?.length >= minLength
				? null
				: {
						minLength: {
							value: `${minLengthLabel || 'This value'} must be at least ${minLength} characters`,
						},
					};
	};
}
